import generateAsyncActions from 'utils/generateAsyncActions';
import alt from 'components/Dispatcher';
import CrmInternalActivitySource from 'sources/crm-opp-ui/CrmInternalActivitySource';

class CrmInternalActivityActions {
  constructor() {
    this.generateActions(...generateAsyncActions('fetchActivity', 'clearActivity'));
  }

  fetchActivity(id) {
    return dispatch => {
      dispatch(id);
      CrmInternalActivitySource.fetchActivity(id).then(
        this.fetchActivitySuccess,
        this.fetchActivityError
      );
    };
  }

  clearActivity() {
    return dispatch => {
      dispatch();
    };
  }
}

export default alt.createActions(CrmInternalActivityActions);
